import { render, staticRenderFns } from "./OrderDetailShipping.vue?vue&type=template&id=c8e1e33e&scoped=true&"
import script from "./OrderDetailShipping.vue?vue&type=script&lang=js&"
export * from "./OrderDetailShipping.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailShipping.vue?vue&type=style&index=0&id=c8e1e33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e1e33e",
  null
  
)

export default component.exports